import React from "react";
import ReactDataGrid from "react-data-grid";

import Api from "../../Api";

export default class AccountStatus extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      rows: []
    };

    this.getColumns = this.getColumns.bind(this);
    this.getRow = this.getRow.bind(this);
    this.getRowCount = this.getRowCount.bind(this);

    this.columns = [
      {
        key: 'name',
        name: 'Name',
        width: 250,
        resizable: true
      },
      {
        key: 'items',
        name: 'Order Items',
        width: 150,
        resizable: true
      },
      {
        key: 'amount',
        name: 'Total amount',
        width: 150,
        resizable: true
      }
    ];
  }

  componentWillMount() {
    let user = Api.cache.getUser(true);
    if (user) {
      this.onUserLoaded(user);
      return;
    }

    Api.getUser().then(
      (userResponse) => {
        user = userResponse;
        this.onUserLoaded(user);
      },
      (error) => {
        console.error('Error getting user: ' + error.message);
      }
    );
  }

  onUserLoaded(user) {
    if (!user.retailer_token) return;

    Api.getAccountStatus(user.retailer_token).then(
      (accountStatus) => {

        let rows = [];
        rows.push({
          name: 'Outstanding order items',
          items: accountStatus.outstanding_items,
          amount: '$' + (Api.Utils.formatCents(accountStatus.outstanding_items_amount_cents) || '0')
        });
        rows.push({
          name: 'Paid order items',
          items: accountStatus.paid_items,
          amount: '$' + (Api.Utils.formatCents(accountStatus.paid_items_amount_cents) || '0')
        });
        rows.push({
          name: 'Cancelled order items',
          items: accountStatus.canceled_items,
          amount: '$' + (Api.Utils.formatCents(accountStatus.canceled_items_amount_cents) || '0')
        });
        rows.push({
          name: 'Order items pending return',
          items: accountStatus.return_pending_items,
          amount: '$' + (Api.Utils.formatCents(accountStatus.return_pending_items_amount_cents) || '0')
        });
        rows.push({
          name: 'Returned ordem items',
          items: accountStatus.returned_items,
          amount: '$' + (Api.Utils.formatCents(accountStatus.returned_items_amount_cents) || '0')
        });
        rows.push({
          name: 'Outstanding Shipments',
          items: accountStatus.outstanding_shipments,
          amount: '$' + (Api.Utils.formatCents(accountStatus.outstanding_shipments_amount_cents) || '0')
        });
        rows.push({
          name: 'Paid Shipments',
          items: accountStatus.paid_shipments,
          amount: '$' + (Api.Utils.formatCents(accountStatus.paid_shipments_amount_cents) || '0')
        });
        rows.push({
          name: 'Untracked Shipments',
          items: accountStatus.untracked_shipments,
          amount: '$' + (Api.Utils.formatCents(accountStatus.untracked_shipments_amount_cents) || '0')
        });

        this.setState({rows: rows});
      },
      (error) => {
        console.error('Error getting account status: ' + error.message);
      }
    );
  }

  getColumns() {
    return this.columns;
  }

  getRow(index) {
    return this.state.rows[index];
  }

  getRowCount() {
    return this.state.rows.length;
  }

  render() {
    return (
      <ReactDataGrid
        enableCellSelect={false}
        columns={this.getColumns()}
        rowGetter={this.getRow}
        rowsCount={this.getRowCount()}
        enableRowSelect={false}
        rowHeight={35}
        minHeight={600}
        rowScrollTimeout={200}
      />
    );
  }
}

export {
  AccountStatus
};



/** WEBPACK FOOTER **
 ** ./src/views/user/account_status.js
 **/